module.exports = __webpack_public_path__ + "img/preview-full-desktop.c19b389e.png";